<template>
  <div class="tenants-view">
    <router-view />
  </div>
</template>

<script>
import View from '@/mixins/View';

export default {
  name: 'tenants-view',
  mixins: [View],
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'tenants',
          route: { name: 'tenants' },
        },
      ];
    },
  },
  i18n: {
    messages: {
      de: {
        breadcrumbs: {
          tenants: 'Mandanten',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// TenantsView.vue?6c0651dc